/**
 * Registers the built-in widget types. Importing '@/dashboard' pulls this in,
 * so 'kpi-group' and 'chart' are available to any DashboardRenderer config.
 * Additional types (table, risk-matrix, heatmap, gauge, ...) register here as
 * they are built.
 */
import { registerWidget } from './registry';
import KpiGroupWidget from './KpiGroupWidget';
import ChartCardWidget from './ChartCardWidget';
import BreakdownChartWidget from './BreakdownChartWidget';
import PssWidget from './PssWidget';
import AiSummaryWidget from './AiSummaryWidget';
import SupervisorWidget from './SupervisorWidget';
import ComparisonTableWidget from './ComparisonTableWidget';
import RecordListWidget from './RecordListWidget';
import SafetyHeroWidget from './SafetyHeroWidget';
import PyramidWidget from './PyramidWidget';
import WorkforceWidget from './WorkforceWidget';
import HighRiskSitesWidget from './HighRiskSitesWidget';
import TopCausesWidget from './TopCausesWidget';
import HighRiskLocationsWidget from './HighRiskLocationsWidget';
import RepeatIncidentsWidget from './RepeatIncidentsWidget';
import RiskMatrixWidget from './RiskMatrixWidget';
import SeriesChartWidget from './SeriesChartWidget';
import SitePerformanceWidget from './SitePerformanceWidget';
import MetricBarWidget from './MetricBarWidget';
import TrainingBreakdownWidget from './TrainingBreakdownWidget';
import ComplianceRegisterWidget from './ComplianceRegisterWidget';
import AttentionWidget from './AttentionWidget';

registerWidget('kpi-group', KpiGroupWidget);
registerWidget('chart', ChartCardWidget);
registerWidget('breakdown', BreakdownChartWidget);
registerWidget('pss', PssWidget);
registerWidget('ai-summary', AiSummaryWidget);
registerWidget('supervisor', SupervisorWidget);
registerWidget('comparison-table', ComparisonTableWidget);
registerWidget('record-list', RecordListWidget);
registerWidget('safety-hero', SafetyHeroWidget);
registerWidget('pyramid', PyramidWidget);
registerWidget('workforce', WorkforceWidget);
registerWidget('high-risk-sites', HighRiskSitesWidget);
registerWidget('top-causes', TopCausesWidget);
registerWidget('high-risk-locations', HighRiskLocationsWidget);
registerWidget('repeat-incidents', RepeatIncidentsWidget);
registerWidget('risk-matrix', RiskMatrixWidget);
registerWidget('series', SeriesChartWidget);
registerWidget('site-performance', SitePerformanceWidget);
registerWidget('metric-bar', MetricBarWidget);
registerWidget('training-breakdown', TrainingBreakdownWidget);
registerWidget('compliance-register', ComplianceRegisterWidget);
registerWidget('attention', AttentionWidget);

// Default column span per type when a config omits colSpan (1 = half, 2 = full).
export const DEFAULT_COLSPAN = {
  'kpi-group': 2,
  chart: 1,
  breakdown: 1,
  pss: 1,
  'ai-summary': 2,
  supervisor: 2,
  'comparison-table': 2,
  'record-list': 1,
  'safety-hero': 2,
  pyramid: 1,
  workforce: 2,
  'high-risk-sites': 1,
  'top-causes': 1,
  'high-risk-locations': 1,
  'repeat-incidents': 2,
  'risk-matrix': 1,
  series: 1,
  'site-performance': 2,
  'metric-bar': 1,
  'training-breakdown': 1,
  // A requirement table needs the full width: five columns, one of
  // which is a long legal title.
  'compliance-register': 2,
  // A backlog strip is read across, not down — always full width.
  attention: 2,
};
